module.exports = __webpack_public_path__ + "static/media/ctv-activation-icon.e94716e0.svg";